exports = module.exports = require("../../../../node_modules/@zxcabs/rtl-css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".error--text .v-text-field__details{text-align:center}body[dir=rtl] .input-form .v-label{right:0!important;left:unset!important}body[dir=rtl] [dir=rtl] .input-form .v-label {\n  left: 0;\n  right: unset;\n}\n", ""]);

// exports
